import { Request } from '@/services/api';

export class SettlementReportsService {
  static list(query?: string, responseType?: 'blob' | 'json') {
    return Request().get(`/admin/settlement/report${query ? query : ''}`, {
      responseType,
    });
  }

  static fetchAllGeneratedReportDates() {
    return Request().get(`/admin/settlement/report/generated-dates`);
  }

  static generateReport(body: any, query: string) {
    return Request().post(`/admin/settlement/report/by/date/range${query}`, body);
  }

  static updateSettlementReportStatus(organizationId: string, id: number, payload: { status: string }) {
    return Request().patch(`/admin/settlement/report/${organizationId}/status/${id}`, payload);
  }

  static uploadReceipt(id: string, query: string, body: FormData) {
    return Request().post(`/admin/settlement/report/${id}/upload/receipt${query}`, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}
